import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IJobState } from "@/store/modules/job/state";
import { JobMutations } from "@/store/modules/job/mutations";
import { RoleMutations } from "@/store/modules/role/mutations";

export enum JobActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_JOB",
  FETCH_ONE = "FETCH_ONE_JOB",
  FETCH_ALL = "FETCH_ALL_JOB",
  CREATE = "CREATE_JOB",
  UPDATE = "UPDATE_JOB",
  DELETE = "DELETE_JOB",
  DELETE_ALL = "DELETE_ALL_JOB",
}

export const actions: ActionTree<IJobState, IRootState> = {
  async [JobActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/users/jobs/list", {
        params: params,
      });
      commit(JobMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch job data provider error: ", error);
    }
  },
  async [JobActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/users/jobs/view/${id}`);
      commit(JobMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch job one error: ", error);
    }
  },
  async [JobActions.FETCH_ALL]({ commit }) {
    try {
      const result = await baseApi.get("/users/users/sub-data/jobs");
      commit(JobMutations.SET_ALL, result.data.data);
    } catch (error) {
      console.log("fetch job one error: ", error);
    }
  },
  async [JobActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/users/jobs/create", data)
        .then((data) => {
          commit(JobMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("job create error: ", error);
          reject(error.response);
        });
    });
  },
  async [JobActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/users/jobs/update/${id}`, data)
        .then((data) => {
          commit(RoleMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("job update error:", error);
          reject(error.response);
        });
    });
  },
  async [JobActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/users/jobs/delete/${id}`);
    } catch (error) {
      console.log("job delete error:", error);
    }
  },
  async [JobActions.DELETE_ALL]({ commit }) {
    try {
      await baseApi.delete(`/users/jobs`);
      commit(JobMutations.SET_ALL, []);
    } catch (error) {
      console.log("company delete all", error);
    }
  },
};
